import React, { useEffect } from 'react';
import { useHouseStore } from '../store/houseStore';
import HouseCard from '../components/HouseCard';
import { Link } from 'react-router-dom';
import { Plus, Loader2 } from 'lucide-react';

const Home: React.FC = () => {
  const { houses, fetchHouses, loading } = useHouseStore();

  useEffect(() => {
    fetchHouses();
  }, [fetchHouses]);

  if (loading && houses.length === 0) {
    return (
      <div className="flex justify-center items-center py-20">
        <Loader2 className="w-8 h-8 animate-spin text-indigo-600" />
      </div>
    );
  }

  if (houses.length === 0) {
    return (
      <div className="text-center py-20">
        <h2 className="text-2xl font-bold text-gray-900 mb-4">No houses tracked yet</h2>
        <p className="text-gray-600 mb-8">Start by adding a property URL to track.</p>
        <Link
          to="/add"
          className="inline-flex items-center px-6 py-3 border border-transparent text-base font-medium rounded-md shadow-sm text-white bg-indigo-600 hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500"
        >
          <Plus className="w-5 h-5 mr-2" />
          Add First House
        </Link>
      </div>
    );
  }

  return (
    <div>
      <div className="flex justify-between items-center mb-6">
        <h1 className="text-2xl font-bold text-gray-900">My Tracked Houses</h1>
        <span className="text-sm text-gray-500">{houses.length} properties</span>
      </div>
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
        {houses.map((house) => (
          <HouseCard key={house.id} house={house} />
        ))}
      </div>
    </div>
  );
};

export default Home;
